<script lang="ts">
    import { scale } from "svelte/transition"
    import { mdiClose } from "@mdi/js"
    import Icon from "./Icon.svelte"

    interface Props {
        showCloseIcon?: boolean
        show?: boolean
        size?: string
        cssClass?: string
        close?: import("svelte").Snippet
        header?: import("svelte").Snippet
        children?: import("svelte").Snippet
        footer?: import("svelte").Snippet
    }

    let {
        showCloseIcon = true,
        show = $bindable(),
        size = "md",
        cssClass = "",
        close,
        header,
        children,
        footer,
    }: Props = $props()
    if (!show) show = false
    const clickOnBackground = () => {
        show = false
    }
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
    onclick={clickOnBackground}
    onkeydown={(e) => e.key === "Escape" && clickOnBackground()}
    class="modal-wrapper {cssClass}"
    class:show
>
    <div class="modal modal-{size}" transition:scale role="document">
        {#if close || showCloseIcon}
            <button
                class="modal-close button transparent"
                type="button"
                aria-label="Close modal"
                tabindex="0"
                onclick={() => {
                    show = false
                }}
            >
                {#if showCloseIcon}
                    <Icon path={mdiClose} size="24px" />
                {/if}
                {@render close?.()}
            </button>
        {/if}
        {#if header}
            <div class="modal-header">
                {#if false}<div></div>{/if}
                {@render header?.()}
            </div>
        {/if}
        {#if children}
            <div class="modal-content">
                {#if false}<div></div>{/if}
                {@render children?.()}
            </div>
        {/if}
        {#if footer}
            <div class="modal-footer">
                {#if false}<div></div>{/if}
                {@render footer?.()}
            </div>
        {/if}
    </div>
</div>

<style lang="less">
    @import "../../css/variables.less";
    .modal-wrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: -1;
        opacity: 0;
        transition: all 0.2s ease-in-out;

        .modal {
            background-color: var(--surface);
            color: var(--on-surface);
            box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
            border-radius: @space-sm;
            transform: translateY(-2rem);
            transition: all 0.4s ease-in-out;
            display: flex;
            flex-direction: column;

            &.modal-xs {
                width: 30vw;
                max-height: 90vh;
            }

            &.modal-sm {
                width: 40vw;
                max-height: 90vh;

                @media screen and (max-width: 1250px) {
                    width: 50vw;
                }
                @media screen and (max-width: 1050px) {
                    width: 60vw;
                }
                @media screen and (max-width: 768px) {
                    width: 95vw;
                }
            }

            &.modal-md {
                width: 50vw;
                max-height: 90vh;

                @media screen and (max-width: 1250px) {
                    width: 60vw;
                }
                @media screen and (max-width: 1050px) {
                    width: 70vw;
                }
                @media screen and (max-width: 768px) {
                    width: 95vw;
                }
            }

            &.modal-lg {
                width: 60vw;
                max-height: 90vh;

                @media screen and (max-width: 1250px) {
                    width: 70vw;
                }
                @media screen and (max-width: 1050px) {
                    width: 80vw;
                }
                @media screen and (max-width: 768px) {
                    width: 95vw;
                }
            }

            &.modal-xl {
                width: 80vw;
                max-height: 90vh;

                @media screen and (max-width: 1050px) {
                    width: 90vw;
                }
                @media screen and (max-width: 768px) {
                    width: 95vw;
                }
            }

            &.modal-full {
                width: 98vw;
                height: 98vw;
                max-height: 98vh;
            }

            & .modal-close {
                position: absolute;
                top: @space-sm;
                right: @space-sm;
            }

            & .modal-content {
                padding: @space-md @space-lg;
                border-radius: @space-lg;
                flex-grow: 1;
                overflow: auto;
            }

            & .modal-header {
                padding: @space-lg @space-lg 0 @space-lg;
                border-top-left-radius: @space-sm;
                border-top-right-radius: @space-sm;
                font-size: 1.5rem;
                line-height: 1.5rem;
                font-weight: 600;

                @media screen and (max-width: 768px) {
                    font-size: 1.2rem;
                    padding: @space-md @space-lg 0 @space-lg;
                }

                & > * {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
            }

            & .modal-footer {
                margin-top: @space-lg;
                padding: 0 @space-lg @space-lg @space-lg;
                border-bottom-left-radius: @space-sm;
                border-bottom-right-radius: @space-sm;

                & > * {
                    display: flex;
                    justify-content: end;
                    gap: @space-sm;
                }
            }
        }

        &.show {
            z-index: 99999;
            opacity: 1;

            & .modal {
                transform: translateY(0);
            }
        }
    }
</style>
